@if (!collapsed) {
  <div class="backdrop" (click)="onclick($event)"></div>
}

<div class="relative">
  <div #ngContentContainer class="hover-pointer" (click)="onclick($event)">
    <ng-content select="[slot=start]" />
  </div>

  @if (!collapsed) {
    <div class="popover-container" [ngStyle]="ngStyle" (click)="onclick($event)">
      <div class="relative">
        <img class="triangle" src="/triangle-bubble.svg" />
      </div>
      <ng-content select="[slot=end]" />
    </div>
  }
</div>
